import { createGuid } from '@bimser/core';
import BCToggleButtonGroup from '../../../../BCToggleButtonGroup';
import { IToggleButtonProps } from '../../../entities';

const ToggleButtonGroupProperty = (props: IToggleButtonProps) => (
	<BCToggleButtonGroup
		key={createGuid()}
		options={props.items}
		style={props.style}
		onChange={props.customChangeEvent}
		singleSelect={props.singleSelect}
		size="small"
	/>
);
export default ToggleButtonGroupProperty;
